export interface IPOISearchScenario {
    id?: string;
    poiType: number;
    firstName: boolean;
    lastName: boolean;
    legalName: boolean;
    alsoKnownAs: boolean;
    dateOfBirth: boolean;
    placeOfBirth: boolean;
    idNumber: boolean;
    leiRegistration: boolean;
    countryInc: boolean;
    socialSecurityNumber: boolean;
    actions?: string;
}

export class POISearchScenario implements IPOISearchScenario{
    id?: string;
    poiType: number;
    firstName: boolean;
    lastName: boolean;
    legalName: boolean;
    alsoKnownAs: boolean;
    dateOfBirth: boolean;
    placeOfBirth: boolean;
    idNumber: boolean;
    leiRegistration: boolean;
    countryInc: boolean;
    socialSecurityNumber: boolean;

    constructor(poiType: number) {
        this.poiType = poiType;
        this.firstName = false;
        this.lastName = false;
        this.legalName = false;
        this.alsoKnownAs = false;
        this.dateOfBirth = false;
        this.placeOfBirth = false;
        this.idNumber = false;
        this.leiRegistration = false;
        this.countryInc = false;
        this.socialSecurityNumber = false;
    }
}

export function copySearchScenario(other: POISearchScenario ): POISearchScenario {
    return {
        id: other.id,
        poiType: other.poiType,
        firstName: other.firstName,
        lastName: other.lastName,
        legalName: other.legalName,
        alsoKnownAs: other.alsoKnownAs,
        dateOfBirth: other.dateOfBirth,
        placeOfBirth: other.placeOfBirth,
        idNumber: other.idNumber,
        leiRegistration: other.leiRegistration,
        countryInc: other.countryInc,
        socialSecurityNumber: other.socialSecurityNumber
    } as POISearchScenario
}